import React from "react";
import "./nav.css";
const NavComponent = ({ img, heading, infoList }) => {
  return (
    <div className="section home-features nav-component-section">
      <div className="container">
        <div className="row align-items-start">
          <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div
              className="image-area aos-animate aos-init "
              style={{ textAlign: "end", marginRight: "15px" }}
            >
              <img src={img} className="img-fluid" alt="platform-design" />
            </div>
          </div>

          <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div className="content">
              <h3 className="aos-init aos-animate">{heading}</h3>

              <div className="features-area">
                <ul>
                  {infoList.map((item, i) => (
                    <li
                      className="aos-item aos-inint aos-animate"
                      style={{ marginTop: "10px", width: "100%" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        className="nav-tab-bottom-wrapper"
                      >
                        <div
                          style={{
                            display: "flex",
                            flexShrink: 0,
                            justifyContent: "center",
                            alignItems: "center",
                            marginRight: "10px",
                          }}
                          className="nav-icon-bottom"
                        >
                          <img
                            style={{
                              flexShrink: 0,
                              marginRight: 0,
                            }}
                            src={item.icon}
                            className="img-fluid  "
                            alt="real-time-data"
                          />
                        </div>
                        <div style={{ textAlign: "left" }}>
                          <h5 style={{ fontWeight: "500" }}>{item.heading}</h5>
                          <p style={{ fontSize: "14px", lineHeight: "20px" }}>
                            {item.para}
                          </p>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavComponent;
